import { ACTIONS } from 'a/pictureThis/data/constants';

export const initialState = {
  offset: { x: 0, y: 0 },
  isActive: true,
  isBeingDragged: false,
  isReturning: false,
};

const draggableGroup = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.SELECT_LEVEL:
      return initialState;

    case ACTIONS.START_GROUP_DRAG:
      return {
        ...state,
        isBeingDragged: true,
      };

    case ACTIONS.STOP_GROUP_DRAG:
      return {
        ...state,
        offset: { x: 0, y: 0 },
        isBeingDragged: false,
        isReturning: true,
      };

    case ACTIONS.GROUP_GOT_HOME:
      return {
        ...state,
        isReturning: false,
      };

    case ACTIONS.UPDATE_GROUP_OFFSET:
      if (payload.offset && payload.offset.x && payload.offset.y) {
        return {
          ...state,
          offset: payload.offset,
        };
      }
      return state;

    case ACTIONS.SET_DRAGGABLE_GROUP_INNACTIVE:
      if (state.element === payload) {
        return {
          ...state,
          offset: initialState.offset,
          isActive: false,
        };
      }
      return state;

    default:
      return state;
  }
};

export default draggableGroup;

export const getIsGroupActive = (state) => {
  if (state) {
    return state.isActive;
  }
  return true;
};

export const getIsGroupDragged = (state) => {
  if (state) {
    return state.isBeingDragged;
  }
  return true;
};

export const getGroupIsReturning = (state) => {
  if (state) {
    return state.isReturning;
  }
  return true;
};

export const getGroupOffset = (state) => {
  if (state) {
    return state.offset;
  }
  return { x: 0, y: 0 };
};

export const getGroupText = (state) => {
  if (state) {
    return state.text;
  }
  return '';
};

export const getGroupUuid = state => state?.uuid;
